import LegalLayout, { H2, H3, UL } from "@/components/layout/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout titleKey="privacy" title="Privacy Policy" testId="legal-privacy-page">
      <H2>Overview</H2>
      <p>AtlasForge Financial respects your privacy and is committed to protecting your personal information.</p>
      <p>This Privacy Policy applies to AtlasForge Financial, Safe to Spend 365, Ember360, our websites, mobile applications, APIs, and related services.</p>

      <H2>Information We Collect</H2>
      <H3>Information You Provide</H3>
      <UL items={["Name", "Email address", "Phone number", "Account profile information", "Support requests", "Payment information"]} />

      <H3>Financial Information</H3>
      <p>With your permission, we may access:</p>
      <UL items={["Account balances", "Transactions", "Financial account information", "Subscription and recurring payment data", "Investment and portfolio information"]} />
      <p>Financial account connectivity is facilitated through trusted providers such as Plaid.</p>

      <H3>Automatically Collected Information</H3>
      <UL items={["Device information", "Browser information", "IP address", "App usage analytics", "Log data", "Security and fraud monitoring information"]} />

      <H2>How We Use Information</H2>
      <p>We use information to:</p>
      <UL items={["Provide Services", "Authenticate users", "Process payments", "Deliver financial insights", "Improve products", "Prevent fraud", "Comply with legal obligations", "Provide customer support"]} />

      <H2>AI Features</H2>
      <p>Safe to Spend 365 and Ember360 may use AI systems to generate financial summaries, forecasts, categorizations, and insights.</p>
      <p>AI-generated outputs may occasionally be inaccurate and should not be treated as professional financial advice.</p>

      <H2>Information Sharing</H2>
      <p>We do not sell personal information.</p>
      <p>We may share information with:</p>
      <UL items={["Service providers", "Payment processors", "Banking connectivity providers", "Analytics providers", "Regulatory authorities when required by law"]} />

      <H2>Data Security</H2>
      <p>We employ administrative, technical, and physical safeguards designed to protect personal information.</p>

      <H2>Data Retention</H2>
      <p>We retain information only as long as necessary to provide Services, comply with legal obligations, resolve disputes, and enforce agreements.</p>

      <H2>Your Rights</H2>
      <p>Depending on your jurisdiction, you may have rights to:</p>
      <UL items={["Access personal data", "Correct personal data", "Delete personal data", "Restrict processing", "Export data"]} />
      <p>Requests may be submitted to customersupport@atlasforgefinancial.com.</p>

      <H2>Children&apos;s Privacy</H2>
      <p>Our Services are not intended for individuals under 18 years of age.</p>

      <H2>Changes to This Policy</H2>
      <p>We may periodically update this Privacy Policy.</p>

      <H2>Contact</H2>
      <p>AtlasForge Financial</p>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
